module.exports = __webpack_public_path__ + "static/media/3.7a4cd155.png";